import lang from './ExportHistoryDialog.lang';

export const TIME_DAY = (LG) => [
  {type: 'hours', name: LG(lang.Hours)},
  {type: 'yesterday', name: LG(lang.Yesterday)},
];

export const TIME_WEEK = (LG) => [
  {type: 'weeks', name: LG(lang.Weeks)},
  {type: 'monthDate', name: LG(lang.MonthDate)},
];

export const TIME_MONTH = (LG) => [
  {type: 'pastMonth', name: LG(lang.PastMonth)},
  {type: 'past3Month', name: LG(lang.Past3Month)},
];
